module.exports = __webpack_public_path__ + "static/media/992468.0e982bab.png";